import React from "react";
import { Expand, Minimize2, Moon } from "lucide-react";
import DispatchHeaderActionMenu, { DispatchHeaderMenuSection } from "./DispatchHeaderActionMenu.jsx";

export default function DispatchGanttViewMenu({ contextKey, isDayDispatchPeriod, isEveningRailOpen, isFleetFullscreen, onEveningRailOpenChange, onFullscreenChange }) {
  const SizeIcon = isFleetFullscreen ? Minimize2 : Expand;
  return <DispatchHeaderActionMenu label="Vue Gantt" contextGroup="view" contextOnly contextKey={contextKey}>
    <DispatchHeaderMenuSection label="Vue Gantt">
      {isDayDispatchPeriod ? <button type="button" role="menuitemcheckbox" tabIndex={-1}
        aria-checked={isEveningRailOpen} className="dispatch-header-menu-action"
        onClick={() => onEveningRailOpenChange?.(!isEveningRailOpen)}>
        <Moon className="h-4 w-4 shrink-0" aria-hidden="true" />
        {isEveningRailOpen ? "Masquer le soir" : "Afficher le soir"}
      </button> : null}
      <button type="button" role="menuitem" tabIndex={-1} className="dispatch-header-menu-action"
        onClick={() => onFullscreenChange(!isFleetFullscreen)}>
        <SizeIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
        {isFleetFullscreen ? "Réduire la vue" : "Agrandir la vue"}
      </button>
    </DispatchHeaderMenuSection>
  </DispatchHeaderActionMenu>;
}
